import { ArrowLeft, Cookie, ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";
import SiteFooter from "../components/SiteFooter";
import ConsentSettingsButton from "../components/ConsentSettingsButton";

export default function PrivacyPage() {
  return (
    <main data-testid="privacy-page">
      <section className="privacy-page container">
        <Link to="/" className="back-link" data-testid="privacy-back-home-link"><ArrowLeft size={17} /> Accueil</Link>
        <p className="eyebrow coral-text">Confidentialité & cookies</p>
        <h1>Vos données,<br /><span>en toute transparence.</span></h1>
        <div className="privacy-content">
          <section><ShieldCheck size={24} /><h2>Vos demandes immobilières</h2><p>Les informations transmises via nos formulaires servent uniquement à répondre à votre projet d’achat, de vente, d’estimation ou de visite. Elles sont adressées à l’équipe Pimp My Place à contact@pimpmyplace.fr.</p></section>
          <section><Cookie size={24} /><h2>Mesure d’audience & publicité</h2><p>Google Analytics 4 (ID de mesure G-96LFDYNBFS) et la balise Google Ads (AW-18358080606, suivi des conversions publicitaires) sont désactivés par défaut. Ils ne s’activent qu’après votre accord explicite. Vous pouvez modifier votre choix à tout moment.</p><ConsentSettingsButton className="privacy-consent-button" testId="privacy-consent-settings-button" /></section>
          <section><ShieldCheck size={24} /><h2>Durée et contact</h2><p>Votre choix de consentement est conservé pendant 12 mois, puis nous vous le redemanderons. Pour toute question concernant vos données, contactez-nous à contact@pimpmyplace.fr.</p></section>
        </div>
      </section>
      <SiteFooter />
    </main>
  );
}